import axios from 'axios';
import { PatientVaccine } from '../models/patient-vaccine';

export const getAppointmentPatientVaccines = async (appointmentId: number): Promise<Undefinable<PatientVaccine[]>> => {
    const response = await axios.get(`/api/patient-vaccine/appointment/${appointmentId}`);
    return response.data;
};
